import { useRef, useState } from 'react';
// @mui
import { Stack, TableRow, TableCell, Typography, IconButton, Menu, MenuItem, useMediaQuery } from '@mui/material';
// components
import Iconify from '../../components/iconify';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

// sections
// mock
import { glb_sv } from 'src/utils';
import { useTranslation } from 'react-i18next';
import Label from 'src/components/label/Label';
import { Cancel, EditOutlined } from '@mui/icons-material';
import ButtonAction from 'src/components/Button.js/SaveButton';

const ItemCategory = ({
    item,
    index,
    addQuantity,
    dataActionRef,
    setVisibleDel,
    handleRomoveProduct,
    setIsVisibleUpdate,
    setNote,
    setQuantity,
    setUserHelper,
    setDataAction,
    setopenSibarDevice,
    userRef,
}) => {
    const anchorTabEdit = useRef(null);
    const [openEdit, setOpenEdit] = useState(false);

    const { t } = useTranslation();
    const isMobile = useMediaQuery('(max-width:750px)');
    return (
        <TableRow hover key={index} tabIndex={-1} role="checkbox">
            <TableCell padding="checkbox"></TableCell>

            <TableCell align="left" style={{ width: '100%', minWidth: '250px' }}>
                <Stack direction="row" alignItems="center" spacing={2}>
                    <img
                        style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '5px',
                            backgroundColor: '#999',
                        }}
                        src={
                            item?.img_device
                                ? `${glb_sv.urlGetProductImage(item?.img_device)}`
                                : `${glb_sv.urlGetProductImage(item?.pic_device)}`
                        }
                        alt=""
                    />
                    <Typography variant="subtitle2">{glb_sv.convertMultipleLanguages(item.device_nm)}</Typography>
                </Stack>
            </TableCell>
            <TableCell align="left">
                <Stack display={'flex'} flexDirection={'column'}>
                    <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                        {t('cabinet')}: {item.cabinet_nm}
                    </Typography>
                    <Typography variant="subtitle3" noWrap>
                        {t('drawer')}: {item.drawer_nm}
                    </Typography>{' '}
                    {item?.cabinet_type === 'square' ? (
                        <Typography variant="subtitle3" noWrap>
                            {t('cell')}: {`[ ${item?.cell_lc?.row || '--'} : ${item?.cell_lc?.column || '--'} ]`}
                        </Typography>
                    ) : (
                        <Typography variant="subtitle3" noWrap>
                            {t('ordinal_number')}: {`[${item?.cell_lc?.column}]`}
                        </Typography>
                    )}
                </Stack>
            </TableCell>

            <TableCell>
                <Label color={(!item.onl && 'secondary') || 'success'}>{item.onl ? 'online' : 'offline'}</Label>
            </TableCell>
            <TableCell align="left">
                <Stack
                    display={'flex'}
                    flexDirection={'row'}
                    gap={0.5}
                    border={'1px solid #999'}
                    borderRadius={'3px'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <IconButton
                        color={'primary'}
                        onClick={() => addQuantity(item, index)}
                        disabled={item.onl && (item.user_id !== userRef.current.id ? true : false)}
                    >
                        <Iconify icon="material-symbols:check-indeterminate-small" width={16} height={16} />
                    </IconButton>
                    <Typography
                        variant="subtitle3"
                        noWrap
                        sx={{
                            fontWeight: '600',
                        }}
                    >
                        {item.qty}
                    </Typography>
                    <IconButton
                        color={'primary'}
                        onClick={() => addQuantity(item, index, 1)}
                        disabled={item.onl && (item.user_id !== userRef.current.id ? true : false)}
                    >
                        <Iconify icon="material-symbols:add" width={16} height={16} />
                    </IconButton>
                </Stack>
            </TableCell>
            <TableCell>{item.note}</TableCell>
            <TableCell>{item?.requester_name ? item?.requester_name : '-----'}</TableCell>
            <TableCell>{item?.helper_name ? item?.helper_name : '-----'}</TableCell>
            <TableCell
                align="left"
                style={{
                    position: 'sticky',
                    right: 0,
                    zIndex: 3,
                    backgroundColor: 'white',
                }}
                ref={anchorTabEdit}
            >
                {isMobile ? (
                    <>
                        <IconButton
                            size="large"
                            // color={'success'}
                            onClick={() => {
                                setOpenEdit(true);
                            }}
                        >
                            <MoreHorizIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorTabEdit.current}
                            open={openEdit}
                            onClose={() => setOpenEdit(false)}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'center',
                            }}
                        >
                            {!item?.onl ||
                            item?.user_id === userRef.current.id ||
                            userRef.current?.group_user?.toString() === '1' ? (
                                <MenuItem
                                    size="large"
                                    color={'error'}
                                    onClick={() => {
                                        if (item.onl) {
                                            dataActionRef.current = item;
                                            setVisibleDel(true);
                                        } else {
                                            handleRomoveProduct(item);
                                        }
                                        setOpenEdit(false);
                                    }}
                                >
                                    <IconButton
                                        color={'error'}
                                        disableRipple
                                        style={{
                                            padding: 0,
                                            margin: 0,
                                        }}
                                    >
                                        <Cancel />
                                        <Typography style={{ marginLeft: 10 }}>{t('delete')}</Typography>
                                    </IconButton>
                                </MenuItem>
                            ) : (
                                <></>
                            )}

                            {item?.onl &&
                                (item?.user_id === userRef.current.id ||
                                    userRef.current?.group_user?.toString() === '1') &&
                                item.helper_id && (
                                    <MenuItem
                                        size="large"
                                        onClick={() => {
                                            dataActionRef.current = item;
                                            setIsVisibleUpdate(true);
                                            setNote(item.note);
                                            setQuantity(item.qty);
                                            setUserHelper(item.helper_id);
                                            setOpenEdit(false);
                                        }}
                                        sx={{ minWidth: 'max-content' }}
                                    >
                                        <IconButton
                                            color={'warning'}
                                            disableRipple
                                            style={{
                                                padding: 0,
                                                margin: 0,
                                            }}
                                        >
                                            <EditOutlined />
                                            <Typography style={{ marginLeft: 10 }}>{t('update')}</Typography>
                                        </IconButton>
                                    </MenuItem>
                                )}

                            <MenuItem
                                size="large"
                                type="confirm"
                                onClick={() => {
                                    dataActionRef.current = item;
                                    setDataAction(item);

                                    setopenSibarDevice(true);
                                    setOpenEdit(false);
                                }}
                            >
                                <IconButton
                                    color={'primary'}
                                    disableRipple
                                    style={{
                                        padding: 0,
                                        margin: 0,
                                    }}
                                >
                                    <Iconify icon="material-symbols:check-circle" />
                                    <Typography style={{ marginLeft: 10 }}>
                                        {item.status_action === '1' ? t('take') : t('borrowing')}
                                    </Typography>
                                </IconButton>
                            </MenuItem>
                        </Menu>
                    </>
                ) : (
                    <Stack display={'flex'} flexDirection={'row'} sx={{ gap: 1 }}>
                        {!item?.onl ||
                        item?.user_id === userRef.current.id ||
                        userRef.current?.group_user?.toString() === '1' ? (
                            <ButtonAction
                                type="delete"
                                title={t('delete')}
                                onClick={() => {
                                    if (item.onl) {
                                        dataActionRef.current = item;
                                        setVisibleDel(true);
                                    } else {
                                        handleRomoveProduct(item);
                                    }
                                }}
                            />
                        ) : (
                            <></>
                        )}

                        {item?.onl &&
                            (item?.user_id === userRef.current.id || userRef.current?.group_user?.toString() === '1') &&
                            item.helper_id && (
                                <ButtonAction
                                    type="update"
                                    title={t('update')}
                                    color={'secondary'}
                                    onClick={() => {
                                        dataActionRef.current = item;
                                        setIsVisibleUpdate(true);
                                        setNote(item.note);
                                        setQuantity(item.qty);
                                        setUserHelper(item.helper_id);
                                    }}
                                    sx={{ minWidth: 'max-content' }}
                                />
                            )}

                        <ButtonAction
                            type="confirm"
                            title={item.status_action === '1' ? t('take') : t('borrowing')}
                            onClick={() => {
                                dataActionRef.current = item;
                                setDataAction(item);

                                setopenSibarDevice(true);
                            }}
                        />
                    </Stack>
                )}
            </TableCell>
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox"></TableCell>
        </TableRow>
    );
};

export default ItemCategory;
